import { setSearchTerm } from "../commissionsDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useCommissionSearch = () => useSearch(s => s.data.listing.commissions.searchTerm, setSearchTerm);
